<template>
  <div class="licevoischet__page">
    <div v-loading="loading">
    <div class="container-fluid">
      <h2 class="page__title">
        <p class="mobile_back noprint" @click="back">
          <svg
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z" fill="#32AAA7" />
          </svg>
        </p>
        <!-- {{$t("Управление трансфертами структуры")}} -->
      </h2>
      <b-row align-v="end" class="row mb-4">
        <div class="col-md-3 uptran">
          <el-autocomplete
            v-model="state"
            :fetch-suggestions="querySearchAsync"
            placeholder="Контекст"
            clearable
            @clear="dd"
            @select="handleSelect"
            style="width: 100%"
          ></el-autocomplete>
        </div>
        <!-- <div class="col-md-6 mt-3 mt-md-0">
          <BasePeriodPicker :currentPeriod="currentPeriod"
          v-on:next-period="nextPeriod" class="period_picker"/>
        </div> -->
        <div class="col-md-3 uptran">
          <el-autocomplete
            v-model="substate"
            :fetch-suggestions="querySearchAsync2"
            placeholder="Корень дерева"
            clearable
            @clear="dd2"
            @select="handleSelect3"
            style="width: 100%"
          ></el-autocomplete>
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <BasePeriodPicker :currentPeriod="currentPeriod"
          v-on:next-period="nextPeriod" class="period_picker"/>
        </div>
      </b-row>
      <!-- <b-row align-v="end" class="row mb-4">
        <div class="col-md-6 mt-3 mt-md-0">
          <BasePeriodPicker :currentPeriod="currentPeriod"
          v-on:next-period="nextPeriod" class="period_picker"/>
        </div>
      </b-row> -->
        <div class="col mb-3 search__btn mobile noprint"
        @click="searchActive = !searchActive">
          <span class="noprint">{{$t("Поиск")}}</span> <span class="search_icons mobi"></span>
        </div>
      <div class="row noprint">
        <div class="col">
          <el-tag
            v-for="tag in tags"
            :key="tag.name"
            closable
            @close="handleClose($event, tag)"
            :type="tag.type"
            :disable-transitions="true"
          >
            {{ tag.name }}
          </el-tag>
        </div>
      </div>
      <div class="row noprint">
        <div class="col-xl-2 show_more_info_mobile" v-show="selectedRow">
          <button class="btn_type_1" @click="showMobileInfo = !showMobileInfo">
            Расшифровка партнёра
          </button>
        </div>
      </div>
      <div class="row noprint" v-if="self_agreementsystem">
        <div class="col-xl-1">
          <button
          :class="`btn_type_1 ${selectedRow ? '' : 'disabled'}`"
          @click="handleSelect2"
          :disabled="!selectedRow"
          >{{$t("Корень")}}</button>
        </div>
        <div class="col-xl-2">
          <button
          :class="`btn_type_1 ${transAccess ? 'disabled' : ''}`"
          @click="showTrans = !showTrans"
          :disabled="transAccess"
          >{{$t("Трансферт")}}</button>
        </div>
        <div class="col-xl-2">
          <button
          class="btn_type_1"
          @click="showGiftPoints = !showGiftPoints"
          >{{$t("Перевести баллы")}}</button>
        </div>
        <div class="col-xl-2" v-show="!massTranseftEdit">
          <button
          v-if="contextAgentInfo.transfert_permission"
          :class="`btn_type_1 ${contextAgentInfo.transfert_permission ? '' : 'disabled'}`"
          :disabled="!contextAgentInfo.transfert_permission"
          @click="massTranseftAction"
          >{{$t("Массовый трансферт")}}</button>
          <button
          v-else
          :class="`btn_type_1 disabled`"
          style="cursor: pointer; !important"
          @click="showError"
          >{{$t("Массовый трансферт")}}</button>
        </div>
        <div class="col-xl-2" v-show="massTranseftEdit">
          <button
          :class="`btn_type_1 ${!canMultiTrans ? 'disabled' : ''}`"
          @click="makeAllTransfer"
          :disabled="!canMultiTrans"
          >{{$t("Применить")}}</button>
        </div>
        <div class="col-xl-2" v-show="massTranseftEdit">
          <button
          :class="`btn_type_2`"
          @click="cancelTransfer"
          >{{$t("Отмена")}}</button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <p style="color: red; font-size: 18px;" class="p-0 m-0">Возможность подачи баллов в трансферт будет ограничена с {{ closeTransfertDate }} числа до открытия следующего месяца</p>
        </div>
      </div>
      <div class="row noprint">
        <div class="col noprint">
          <p class="exp_print noprint">
            <span class="mr-3" @click="downloadPdf">{{$t("Экспорт в pdf")}}</span>
            <span class="mr-3" @click="downloadXls">{{$t("Экспорт в xlsx")}}</span>
            <span class="mr-3" v-b-modal.modal-scrollable>{{$t("Легенда")}}</span>
            <span class="mr-3" v-if="selectedRow"
            @click="setCurrent()">{{$t("Снять выделение")}}</span>
          </p>
        </div>
      </div>
      <div class="transmaneg_table mb-3 mt-3">
        <el-table
        :data="entries"
        header-row-class-name='headerClass'
        :row-class-name="tableRowClassName"
        border
        :resizable="false"
        ref="singleTable"
        highlight-current-row
        @current-change="handleCurrentChange"
        height="60vh"
        >
          <el-table-column
          v-for="column in fields"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :resizable="false"
          :min-width="colMinWidth(column.key)"
          :width="colWidth(column.key)"
          >
          <template slot-scope="scope">
            <div v-if="column.key === 'id'">
              <p style="margin: 0;">
                <span class="mr-2">{{ scope.row.lvl }} {{$t("УР")}}</span>
                <router-link class="link" :to="`/agent/${scope.row.id}`">
                <span style="display: inline-block;">{{ scope.row.id }}</span><br>
                </router-link>
              </p>
            </div>
            <div v-else-if="column.key === 'rang_icon'">
              <p style="margin: 0; text-align: center;">
              <img :src="`../icons/${scope.row.rank_calc}${scope.row.lvl==='0'?'_white':''}.svg`"
              :title="scope.row.rank_end" class="rank_icon" />
              </p>
              <p style="text-align: right; margin: 0">{{ scope.row.fio }}</p>
            </div>
            <div v-else-if="column.key === 'isterminated'">
              {{scope.row.isterminated === '0' ? 'Нет' : 'Да'}}
            </div>
            <!-- <div v-else-if="column.key === 'rank_end_npp'">
              {{scope.row.rank_end}}
            </div> -->
            <div v-else-if="column.key === 'reserve'">
              <router-link class="link" :to="`/points-history/${scope.row.id}`" style="text-decoration: underline;">
              {{ scope.row.reserve }}
              </router-link>
            </div>
            <!-- <div v-else-if="column.key === 'rank_beg_npp'">
              {{scope.row.rank_beg}}
            </div> -->
            <div v-else-if="column.key === 'go'">
               <span @click.stop="showGo(scope.row)" style="cursor: pointer; text-decoration: underline">{{scope.row.go | localInt}}</span>
            </div>
            <div v-else-if="column.key === 'rank_calc_npp'">
              {{scope.row.rank_calc}}
            </div>
            <div v-else-if="['lo', 'ngo', 'oo', 'ko', 'reserve'].includes(column.key)">
              {{scope.row[column.key] | localInt}}
            </div>
            <div v-else-if="['transfer_only', 'external_lo'].includes(column.key)">
              {{scope.row[column.key] | localInt}}
            </div>
            <div v-else-if="column.key === 'trans'">
              <CustomInput :rowa="scope.row" v-if="scope.row.is_can_transfer"/>
            </div>
            <div v-else-if="column.key === 'cityname'">
              {{scope.row.cityname}}
            </div>
            <div v-else>
              {{scope.row[column.key]}}
            </div>
          </template>
          </el-table-column>
          <infinite-loading
          slot="append"
          :identifier="infiniteId"
          force-use-infinite-wrapper=".el-table__body-wrapper"
          ref='infinit'
          spinner="waveDots"
          @infinite="infiniteHandler">
            <div slot="no-more">{{$t("Все данные загружены")}}</div>
          </infinite-loading>
        </el-table>
      </div>
    </div>
    </div>
      <footer class="container-fluid cust_modal noprint">
      <div class="row desk_trans">
        <div class="col text-center search__btn desktop"
        @click="searchActive = !searchActive" v-if="!searchActive">
          {{$t("Поиск")}} <span class="search_icons"></span>
        </div>
      </div>
      <div v-if="searchActive" class="organization__modal container">
        <span @click="searchActive = !searchActive" class="close_btn"></span>
        <h3 class="mt-4">{{$t("Поиск партнера")}}</h3>
        <div class="row mt-md-5">
          <div class="col-xl-6">
            <b-form-group label="Выбор дерева">
              <b-form-radio
                v-model="tree_type"
                name="some-radios-1"
                value="0"
                class="radio mr-3"
                >{{$t("Полное дерево")}}</b-form-radio
              >
              <b-form-radio
                v-model="tree_type"
                name="some-radios-1"
                value="1"
                class="radio mr-3"
                >{{$t("Директорское")}}</b-form-radio
              >
              <b-form-radio v-model="tree_type" name="some-radios-1" value="2" class="radio"
                >{{$t("Личная группа")}}</b-form-radio
              >
            </b-form-group>
          </div>
          <div class="col-xl-6 qq">
            <b-form-checkbox
              id="checkbox-1"
              v-model="filterData.status"
              name="checkbox-1"
              :value="1"
              checked
              :unchecked-value="0"
            >
              {{$t("Показывать терминированных")}}
            </b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-form-group label="ЛО">
              <b-form-radio v-model="lo_type" name="some-radios-2" :value="1" class="radio mr-3">
                Положительное
              </b-form-radio>
              <b-form-radio v-model="lo_type" name="some-radios-2" :value="-1" class="radio mr-3">
                Отрицательное
              </b-form-radio>
              <b-form-radio v-model="lo_type" name="some-radios-2" :value="0" class="radio mr-3">
                Нулевое
              </b-form-radio>
              <b-form-radio v-model="lo_type" name="some-radios-2" :value="2" class="radio mr-3">
                Ненулевое
              </b-form-radio>
              <b-form-radio v-model="lo_type" name="some-radios-2" :value="3" class="radio">
                Все
              </b-form-radio>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Резерв">
              <b-form-radio v-model="reserve_type" name="some-radios-3" :value="1" class="radio mr-3">
                Положительный
              </b-form-radio>
              <b-form-radio v-model="reserve_type" name="some-radios-3" :value="-1" class="radio mr-3">
                Отрицательный
              </b-form-radio>
              <b-form-radio v-model="reserve_type" name="some-radios-3" :value="0" class="radio mr-3">
                Нулевой
              </b-form-radio>
              <b-form-radio v-model="reserve_type" name="some-radios-3" :value="2" class="radio mr-3">
                Ненулевой
              </b-form-radio>
              <b-form-radio v-model="reserve_type" name="some-radios-3" :value="3" class="radio">
                Все
              </b-form-radio>
            </b-form-group>
          </div>
        </div>
        <div class="row mt-md-5">
          <div class="col-md-6 custom_input">
            <input type="text" name="userId" id="userId" required v-model="filterData.agent_id"/>
            <label for="userId">{{$t("Номер")}}</label>
            <span class="clear_icon" @click="clearInput('agent_id')"></span>
          </div>
          <div class="col-md-6 custom_input">
            <input type="text" name="userFio" id="userFio" required v-model="filterData.fullname"/>
            <label for="userFio">{{$t("ФИО")}}</label>
            <span class="clear_icon" @click="clearInput('fullname')"></span>
          </div>
        </div>
        <div class="row mt-md-5">
          <div class="col-md-6">
            <span
            v-if="filterData.area_id"
            class="custom_label"
            >
            {{$t("Территория")}}</span>
            <el-select
            v-model="filterData.area_id"
            clearable
            @clear="clearRegion"
            :placeholder="`${$t('Территория')}`">
              <el-option
                v-for="item in areaList"
                :key="item.area_id"
                :label="item.area_name"
                :value="item.area_id">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-6">
            <span
            v-if="filterData.rank_calc"
            class="custom_label"
            >
            {{$t("Расчетный ранг")}}</span>
            <el-select
            v-model="filterData.rank_calc"
            clearable
            :placeholder="`${$t('Расчетный ранг')}`">
              <el-option
                v-for="item in rankList"
                :key="item.rankname"
                :label="item.rankname"
                :value="item.rankname">
              </el-option>
            </el-select>
          </div>
          <!-- <div class="col-md-6 custom_input">
            <input type="text" name="userStore" id="userStore" required v-model="filterData.store"/>
            <label for="userStore">{{$t("Город склада обслуживания")}}</label>
            <span class="clear_icon" @click="clearInput('store')"></span>
          </div> -->
        </div>
        <!-- <div class="row mt-md-5">
          <div class="col-md-6">
            <span
            v-if="filterData.rank_beg"
            class="custom_label"
            >
            {{$t("Ранг на начало")}}</span>
            <el-select
            v-model="filterData.rank_beg"
            clearable
            :placeholder="`${$t('Ранг на начало')}`">
              <el-option
                v-for="item in rankList"
                :key="item.rankname"
                :label="item.rankname"
                :value="item.rankname">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-6">
            <span
            v-if="filterData.rank_end"
            class="custom_label"
            >
            {{$t("Ранг на конец")}}</span>
            <el-select
            v-model="filterData.rank_end"
            clearable
            :placeholder="`${$t('Ранг на конец')}`">
              <el-option
                v-for="item in rankList"
                :key="item.rankname"
                :label="item.rankname"
                :value="item.rankname">
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="row mt-md-4">
          <div class="col-md-6">
            <!-- <span
            v-if="filterData.rank_calc"
            class="custom_label"
            >
            {{$t("Расчетный ранг")}}</span>
            <el-select
            v-model="filterData.rank_calc"
            clearable
            :placeholder="`${$t('Расчетный ранг')}`">
              <el-option
                v-for="item in rankList"
                :key="item.rankname"
                :label="item.rankname"
                :value="item.rankname">
              </el-option>
            </el-select> -->
          </div>
          <div class="col-md-6 custom_input">
            <div style="display: flex; justify-content: space-between; gap: 20px">
              <button class="update w-50" @click="updateData">{{$t("Применить")}}</button>
              <button class="update w-50" @click="resetData">{{$t("Сбросить")}}</button>
            </div>
          </div>
        </div>
      </div>
      </footer>
      <footer class="container-fluid cust_modal" v-if="showTrans">
        <div>
          <TransfertMass v-on:enlarge-text="showTrans = false" :id="id" :context="currentUserId" :upPeriod="periodIndex" @action="updateTable"/>
        </div>
      </footer>
      <footer class="container-fluid cust_modal" v-if="showGiftPoints">
        <div>
          <AgentInfoModalGiftPointsTransfert
          v-on:close="showGiftPoints = !showGiftPoints"
          v-on:enlarge-text="pointsAction"
          :id="currentUserId"/>
        </div>
      </footer>
      <footer class="container-fluid cust_modal" v-show="showGoDetails">
        <div class="container-md">
          <div class="organization__modal goInfoTable">
            <h4 class="mt-3" style="position: relative;">{{whichGOShow}} <span class="ml-3">
              ГО: {{selectedRowGoValue | localInt }}</span>
              <span v-show="showMissedGO" class="ml-3" style="color: red;">Недополученное ГО: {{ howMuchMissedGO | localInt }}</span><span style="color: #32aaa7;
            font-size: 16px; cursor: pointer;" class="ml-4" @click="exportGoPDF(GOSelectedRowID)">Экспорт в PDF</span> <span class="close_btn" @click="showGoDetails = !showGoDetails"></span></h4>
            <b-table :fields="goFields" small sticky-header :items="goEntries" bordered outlined height="40vh" responsive head-variant="light" class="mt-3">
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'lvl' || field.key === 'order' || field.key === 'id' ? '100px' : '' }"
                >
              </template>
              <template #cell(lo)="data">
                {{data.value | localInt}}
              </template>
            </b-table>
          </div>
        </div>
      </footer>
      <!-- Расшифровка (информация по выделенной строке) -->
      <div class="col-3 selectedUserInfo_wrapper" v-if="selectedRow">
        <div class="selected_user_info_block">
          <div @click="showUserInfoBlock = !showUserInfoBlock" style="cursor: pointer" class="selected_user_info_block_header">
            <h4 class="text-center"> Расшифровка</h4>
            <h5 class="text-center">{{properId}} - {{properName}}</h5>
            <span class="plus_btn">{{showUserInfoBlock ? '-' : '+'}}</span>
          </div>
          <hr v-show="showUserInfoBlock">
          <div class="row" v-show="showUserInfoBlock">
            <div class="col-6">
              <span>ЛО:</span><br>
              <span>{{selectedRowAgentInfo.lo | localInt}}</span>
            </div>
            <div class="col-6">
              <span>ГО:</span><br>
              <span>{{selectedRowAgentInfo.go | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>НГО:</span><br>
              <span>{{selectedRowAgentInfo.ngo | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>ОО:</span><br>
              <span>{{selectedRowAgentInfo.oo | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>КО:</span><br>
              <span>{{selectedRowAgentInfo.ko | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Пропорц.:</span><br>
              <span>{{proportional}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Ранг на начало:</span><br>
              <span>{{selectedRowAgentInfo.rank_beg}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Расчётный ранг:</span><br>
              <span>{{selectedRowAgentInfo.rank_calc}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Ранг на конец:</span><br>
              <span>{{selectedRowAgentInfo.rank_end}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Тип соглашения:</span><br>
              <span>{{selectedRowAgentInfo.entrytype}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Активность:</span><br>
              <span>{{selectedRowAgentInfo.act}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Ранг:</span><br>
              <span>-</span>
            </div>
            <div class="col-6 mt-2">
              <span>Клиент:</span><br>
              <span>{{selectedRowAgentInfo.cnt_client}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Консультант:</span><br>
              <span>{{selectedRowAgentInfo.cnt_consultant}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Мастер:</span><br>
              <span>{{selectedRowAgentInfo.cnt_master}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Управляющий:</span><br>
              <span>{{selectedRowAgentInfo.cnt_manager}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_director}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Сер. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_silver}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Зол. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_gold}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Руб. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_ruby}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Брилл. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_diamond}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Президент:</span><br>
              <span>{{selectedRowAgentInfo.cnt_president}}</span>
            </div>
            <!-- <div class="col mt-2" v-if="(!isThisCurrentPeriod && properInHearar && (properNoClient) && stockInfo.transfert_permission)">
              <span>Разрешение трансферта:</span><br>
                <b-form-group :disabled="isBlockTransSwitch">
                  <b-form-radio-group
                    id="radio-group-1"
                    @change="changeTransAccess"
                    v-model="selectedRowAgentInfo.transfert_permission"
                    name="radio-sub-component-1"
                  >
                    <b-form-radio :value="1" >
                      {{$t("Разрешен")}}
                    </b-form-radio>
                    <b-form-radio :value="0" >
                      {{$t("Запрещен")}}
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
            </div> -->
          </div>
        </div>
      </div>
      <!-- Расшифровка (информация по выделенной строке) Мобильная -->
      <div class="col-md-3 selectedUserInfo_wrapper_mobile" v-if="selectedRow && showMobileInfo">
        <div class="selected_user_info_block">
          <div @click="showMobileInfo = !showMobileInfo" style="cursor: pointer" class="selected_user_info_block_header">
            <h4 class="text-center"> Расшифровка</h4>
            <h5 class="text-center">{{properId}} - {{properName}}</h5>
            <span class="plus_btn">{{showUserInfoBlock ? 'X' : 'X'}}</span>
          </div>
          <hr>
          <div class="row">
            <div class="col-6">
              <span>ЛО:</span><br>
              <span>{{selectedRowAgentInfo.lo | localInt}}</span>
            </div>
            <div class="col-6">
              <span>ГО:</span><br>
              <span>{{selectedRowAgentInfo.go | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>НГО:</span><br>
              <span>{{selectedRowAgentInfo.ngo | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>ОО:</span><br>
              <span>{{selectedRowAgentInfo.oo | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>КО:</span><br>
              <span>{{selectedRowAgentInfo.ko | localInt}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Пропорц.:</span><br>
              <span>{{proportional}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Ранг на начало:</span><br>
              <span>{{selectedRowAgentInfo.rank_beg}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Расчётный ранг:</span><br>
              <span>{{selectedRowAgentInfo.rank_calc}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Ранг на конец:</span><br>
              <span>{{selectedRowAgentInfo.rank_end}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Тип соглашения:</span><br>
              <span>{{selectedRowAgentInfo.entrytype}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Активность:</span><br>
              <span>{{selectedRowAgentInfo.act}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Ранг:</span><br>
              <span>-</span>
            </div>
            <div class="col-6 mt-2">
              <span>Клиент:</span><br>
              <span>{{selectedRowAgentInfo.cnt_client}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Консультант:</span><br>
              <span>{{selectedRowAgentInfo.cnt_consultant}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Мастер:</span><br>
              <span>{{selectedRowAgentInfo.cnt_master}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Управляющий:</span><br>
              <span>{{selectedRowAgentInfo.cnt_manager}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_director}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Сер. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_silver}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Зол. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_gold}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Руб. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_ruby}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Брилл. Директор:</span><br>
              <span>{{selectedRowAgentInfo.cnt_diamond}}</span>
            </div>
            <div class="col-6 mt-2">
              <span>Президент:</span><br>
              <span>{{selectedRowAgentInfo.cnt_president}}</span>
            </div>
            <!-- <div class="col mt-2" v-if="(!isThisCurrentPeriod && properInHearar && (properNoClient) && stockInfo.transfert_permission)">
              <span>Разрешение трансферта:</span><br>
                <b-form-group :disabled="isBlockTransSwitch">
                  <b-form-radio-group
                    id="radio-group-1"
                    @change="changeTransAccess"
                    v-model="selectedRowAgentInfo.transfert_permission"
                    name="radio-sub-component-1"
                  >
                    <b-form-radio :value="1" >
                      {{$t("Разрешен")}}
                    </b-form-radio>
                    <b-form-radio :value="0" >
                      {{$t("Запрещен")}}
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
            </div> -->
          </div>
        </div>
      </div>
      <b-modal id="bv-modal-load-go" hide-footer centered  :hide-header-close="true" :no-close-on-backdrop="true">
        <div class="d-block text-center">
          <h3>
            {{$t('Загрузка расшифровки ГО')}}
          </h3>
          <p>{{$t("Пожалуйста подождите")}}...</p>
        </div>
      </b-modal>
  <b-modal v-model="show"
  id="modal-scrollable" centered scrollable title="Легенда">
    <div class="modal_icons">
      <img :src="`../icons/Клиент.svg`"
      class="rank_icon_legend"> <span>{{$t("Привилегированный клиент")}}</span></div> <br>
    <div class="modal_icons">
      <img :src="`../icons/Консультант.svg`"
      class="rank_icon_legend"> <span>{{$t("Консультант")}}</span></div><br>
    <div class="modal_icons">
      <img :src="`../icons/Мастер.svg`"
      class="rank_icon_legend"><span>{{$t("Мастер")}}</span></div><br>
    <div class="modal_icons">
      <img :src="`../icons/Управляющий.svg`"
      class="rank_icon_legend"><span>{{$t("Управляющий")}}</span></div><br><br>
    <div class="modal_icons">
      <img :src="`../icons/Директор.svg`"
      class="rank_icon_legend"><span>{{$t("Директор")}}</span></div><br>
    <div class="modal_icons"><img :src="`../icons/Серебряный Директор.svg`"
    class="rank_icon_legend">
    <span>{{$t("Серебряный Директор")}}</span></div><br>
    <div class="modal_icons"><img :src="`../icons/Золотой Директор.svg`"
    class="rank_icon_legend">
    <span>{{$t("Золотой Директор")}}</span></div><br><br>
    <div class="modal_icons"><img :src="`../icons/Рубиновый Директор.svg`" class="rank_icon_legend">
    <span>{{$t("Рубиновый Директор")}}</span></div><br>
    <div class="modal_icons"><img :src="`../icons/Бриллиантовый Директор.svg`"
    class="rank_icon_legend">
    <span>{{$t("Бриллиантовый Директор")}}</span></div><br>
    <div class="modal_icons">
      <img :src="`../icons/Президент.svg`"
      class="rank_icon_legend"><span>{{$t("Президент")}}</span></div><br>
    <template #modal-footer>
          <b-button
            variant="primary"
            size="sm"
            class="float-right cls_btn"
            @click="show=false"
          >
            {{$t("Закрыть")}}
          </b-button>
    </template>
  </b-modal>
    <b-modal id="bv-modal-load" hide-footer centered  :hide-header-close="true" :no-close-on-backdrop="true">
      <div class="d-block text-center">
        <h3>
          {{$t('Обновление данных')}}
        </h3>
        <p>{{$t("Пожалуйста подождите")}}...</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import InfiniteLoading from 'vue-infinite-loading';
import { mapActions, mapGetters, mapState } from 'vuex';
import $ from 'jquery';
import backApi from '../assets/backApi';
import TransfertMass from '../components/TransfertMass.vue';
import CustomInput from '../components/CustomInput.vue';
import BasePeriodPicker from '../components/BasePeriodPicker.vue';
import AgentInfoModalGiftPointsTransfert from '../components/AgentInfoModalGiftPointsTransfert.vue';

export default {
  name: 'TransferManagement',
  components: {
    TransfertMass,
    CustomInput,
    InfiniteLoading,
    BasePeriodPicker,
    AgentInfoModalGiftPointsTransfert,
  },
  data() {
    return {
      showMobileInfo: false,
      showGoDetails: false,
      selectedRowGoValue: null,
      selectedRowAgentInfo: {},
      GOSelectedRowID: null,
      showUserInfoBlock: false,
      whichGOShow: '',
      closeTransfertDate: '',
      periods: [],
      periodIndex: 0,
      selectedRow: null,
      infiniteId: +new Date(),
      offset: 0,
      count: 15,
      transMass: [],
      entriesCache: new Map(),
      massTranseftEdit: false,
      lower: '<= 0',
      show: false,
      showGiftPoints: false,
      state: '',
      substate: '',
      links: [],
      id: null,
      options: [],
      contextAgentInfo: {},
      currentUserId: null,
      currentSubUserId: null,
      currentSubUser: null,
      transAccess: true,
      showTrans: false,
      loading: true,
      tree_type: 2,
      lo_type: 3,
      reserve_type: 3,
      tags: [],
      searchActive: false,
      filterData: {
        status: 1,
      },
      lo_types: {
        '-1': 'Отрицательный',
        0: 'Нулевой',
        1: 'Положительный',
        2: 'Ненулевой',
        3: 'Все',
      },
      reserve_types: {
        '-1': 'Отрицательный',
        0: 'Нулевой',
        1: 'Положительный',
        2: 'Ненулевой',
        3: 'Все',
      },
      rankList: [],
      areaList: [],
      entries: [],
      fields: [
        {
          key: 'id',
          label: this.$t('P/номер'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
        },
        {
          key: 'rang_icon',
          label: this.$t('Ранг'),
        },
        {
          key: 'name',
          label: this.$t('ФИО'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
        },
        {
          key: 'noact',
          label: this.$t('Неакт.'),
          formater: (item) => item.noact,
          sortable: true,
        },
        {
          key: 'reserve',
          label: this.$t('Резерв'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          // sortable: true,
        },
        // {
        //   key: 'trans',
        //   label: 'Трансферт',
        // },
        {
          key: 'transfer_only',
          label: this.$t('Трансферт из НС'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'external_lo',
          label: this.$t('Внешний трансферт'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'lo',
          label: this.$t('Итоговый трансферт'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'go',
          label: this.$t('ГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ngo',
          label: this.$t('НГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'oo',
          label: this.$t('ОО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ko',
          label: this.$t('КО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        // {
        //   key: 'proportional',
        //   label: this.$t('Выполнение Пропорц. %'),
        //   formater: (item) => item.noact,
        //   sortable: true,
        // },
        // {
        //   key: 'rank_beg_npp',
        //   label: this.$t('Ранг на начало'),
        //   formater: (item) => item.rank_beg,
        //   sortable: true,
        // },
        {
          key: 'rank_calc_npp',
          label: this.$t('Расчетный ранг'),
          formater: (item) => item.rank_calc,
          sortable: true,
        },
        // {
        //   key: 'rank_end_npp',
        //   label: this.$t('Ранг на конец'),
        //   sortable: true,
        // },
        {
          key: 'cityname',
          label: this.$t('Город'),
          formater: (item) => item.cityname,
          sortable: true,
        },
        {
          key: 'areaname',
          label: this.$t('Территория'),
          formater: (item) => item.areaname,
          sortable: true,
        },
        {
          key: 'isterminated',
          label: this.$t('Терм.'),
          // formatter: (item) => {
          //   if (item.isterminated === 0) {
          //     return 'Нет';
          //   }
          //   return 'Да';
          // },
          sortable: true,
        },
      ],
      months: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
      goFields: [
        {
          key: 'ord',
          label: 'Номер п/п',
          sortable: true,
        },
        {
          key: 'niv',
          label: 'УР.',
          sortable: true,
        },
        {
          key: 'agent_id',
          label: 'ID Партнёра',
          sortable: true,
        },
        {
          key: 'agent_name',
          label: 'ФИО',
          sortable: true,
        },
        {
          key: 'lo',
          label: 'ЛО',
          sortable: true,
        },
        {
          key: 'parent_id',
          label: 'ID Спонсора',
          sortable: true,
        },
        {
          key: 'parent_name',
          label: 'ФИО Спонсора',
          sortable: true,
        },
      ],
      goEntries: [],
    };
  },
  created() {
    document.addEventListener('keydown', this.enterActionWithTransfert);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.enterActionWithTransfert);
  },
  destroyed() {
  },
  mounted() {
    this.tags.push({ name: 'Показывать терминированных', key: 'status' });
    this.tags.push({ name: 'ЛО: Все', key: 'lo_type' });
    this.tags.push({ name: 'Резерв: Все', key: 'reserve_type' });
    backApi.get('/agent/open-periods').then((Response) => {
      this.periods = Response.data.entries.sort((a, b) => {
        const result = a.period > b.period ? 1 : -1;
        return result;
      });
      this.periodIndex = this.periods.length - 1;
    });
    backApi.get('/agent/options/90').then((Response) => {
      this.closeTransfertDate = Response.data.options_value;
    });
  },
  metaInfo() {
    this.setPageTitle(this.$t('Управление трансфертами структуры'));
    return {
      title: `${this.$t('ЛК Партнера')} - ${this.$t('Управление трансфертами структуры')}`,
    };
  },
  methods: {
    createMessageBox2(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [h('h3', { class: ['text-center'] }, [messageText])]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        buttonSize: 'md',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'Да',
        size: 'xl',
      });
    },
    exportGoPDF(id) {
      backApi.get(`/agent/go-detail/${id}/pdf`,
        { params: { comdte: this.periods[this.periodIndex].period }, responseType: 'blob' }).then(({ data }) => {
        const filename = `Расшифровка "ГО": ${this.whichGOShow}.pdf`;
        const url = window.URL.createObjectURL(new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    async showGo(payload) {
      console.log(payload);
      this.goEntries = [];
      const res = await this.createMessageBox2(`Просмотреть расшифровку "ГО": ${payload.id} - ${payload.name}?`);
      if (res) {
        this.$bvModal.show('bv-modal-load-go');
        this.whichGOShow = `${payload.id} - ${payload.name}`;
        this.GOSelectedRowID = payload.id;
        this.selectedRowGoValue = Number(String(payload.go).replace(/\s/g, '').replace(/[,]/g, '.'));
        await backApi.get(`/agent/go-detail/${payload.id}`, { params: { comdte: this.periods[this.periodIndex].period } })
          .then((Response) => {
            this.goEntries = Response.data.entries;
            this.$bvModal.hide('bv-modal-load-go');
            this.showGoDetails = true;
          }).catch(() => {
            this.$bvModal.hide('bv-modal-load-go');
            this.showToast(
              this.$t('Ошибка'),
              this.$t('Что-то пошло не так'),
              'danger',
            );
          });
      }
    },
    showError() {
      this.showToast('Трансферт', `Трансферт за ${this.months[new Date(this.currentPeriod).getMonth()]}
      ${new Date(this.currentPeriod).getFullYear()} отправлен в расчет. Изменения невозможны`, 'danger');
    },
    enterActionWithTransfert(e) {
      if ((e.code === 'Enter' || e.code === 'NumpadEnter') && this.massTranseftEdit) {
        if (document.activeElement.getAttribute('name') === 'transInput') {
          if ($(document.activeElement.closest('.el-table__row')).nextAll('.can_trans').eq(0).find('input[name="transInput"]').length) {
            $(document.activeElement.closest('.el-table__row')).nextAll('.can_trans').eq(0)[0].click();
            $(document.activeElement.closest('.el-table__row')).nextAll('.can_trans').eq(0)[0].scrollIntoView({
              behavior: 'auto',
              block: 'center',
              inline: 'center',
            });
            $(document.activeElement.closest('.el-table__row')).nextAll('.can_trans').eq(0).find('input[name="transInput"]')[0].select();
          } else {
            document.querySelector('.el-table__body-wrapper').scrollTop = document.querySelector('.el-table__body-wrapper').scrollHeight;
          }
        } else if (document.querySelectorAll('input[name="transInput"]').length) {
          document.querySelectorAll('input[name="transInput"]')[0].closest('.can_trans').click();
          document.querySelectorAll('input[name="transInput"]')[0].closest('.can_trans').scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center',
          });
          document.querySelectorAll('input[name="transInput"]')[0].select();
        } else {
          document.querySelector('.el-table__body-wrapper').scrollTop = document.querySelector('.el-table__body-wrapper').scrollHeight;
        }
      }
    },
    createMessageBoxError(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('h5', { class: ['text-center'] }, [messageText]),
      ]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxOk([messageVNode], {
        buttonSize: 'xl',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'OK',
        size: 'md',
      });
    },
    async pointsAction({ to, from }) {
      this.$bvModal.show('bv-modal-load');
      await backApi.get('agent/transfer-info', { params: { another_agent_id: from } }).then((Response) => {
        $(`.userid-${from}`).find('.reserve').text(Response.data.reserve);
        this.updateUserTransfertData({ id: from, newReserve: Response.data.reserve });
      });
      if ($(`.userid-${to}`).length !== 0) {
        const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
        const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

        const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
        const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

        const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
        const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

        const data = {
          params: {
            comdte: this.periods[this.periodIndex].period,
            // eslint-disable-next-line radix
            with_terminated: parseInt(this.filterData.status),
            tree_type: this.tree_type,
            agent_id: this.currentUserId,
            num: this.filterData.agent_id,
            fullname: this.filterData.fullname,
            area_id: this.filterData.area_id,
            city: this.filterData.store,
            i_rank_beg: rankBeg,
            i_status_beg: statusBeg,
            i_rank_calc: rankCalc,
            i_status_calc: statusCalc,
            i_rank_end: rankEnd,
            i_status_end: statusEnd,
            i_lo: this.lo_type,
            i_reserve: this.reserve_type,
            offset: 0,
            count: Number(this.entries.length),
            sub_agent_id: this.currentSubUserId,
          },
        };
        await backApi.get('/agent/flat_genealogy', data).then((Response) => {
          const reserveVal = Response.data.entries.find((user) => user.id === to).reserve;
          $(`.userid-${to}`).find('.reserve').text(reserveVal);
          this.updateUserTransfertData({ id: to, newReserve: reserveVal });
        });
        this.$bvModal.hide('bv-modal-load');
        await this.createMessageBoxError('Операция выполнена успешно');
        this.showGiftPoints = false;
        return;
      }
      this.$bvModal.hide('bv-modal-load');
      await this.createMessageBoxError('Операция выполнена успешно');
      this.showGiftPoints = false;
    },
    updateTable() {
      const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
      const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

      const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
      const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

      const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
      const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

      const data = {
        params: {
          // eslint-disable-next-line radix
          with_terminated: parseInt(this.filterData.status),
          comdte: this.periods[this.periodIndex].period,
          tree_type: this.tree_type,
          agent_id: this.currentUserId,
          num: this.filterData.agent_id,
          fullname: this.filterData.fullname,
          area_id: this.filterData.area_id,
          city: this.filterData.store,
          i_rank_beg: rankBeg,
          i_status_beg: statusBeg,
          i_rank_calc: rankCalc,
          i_status_calc: statusCalc,
          i_rank_end: rankEnd,
          i_status_end: statusEnd,
          i_lo: this.lo_type,
          i_reserve: this.reserve_type,
          offset: 0,
          count: Number(this.entries.length),
          sub_agent_id: this.currentSubUserId,
        },
      };
      const treeNameTranslate = {
        2: 'Личная группа',
        0: 'Полное дерево',
        1: 'Директорское',
      };
      // Тип дерева
      if (this.tree_type !== null) {
        const treeName = treeNameTranslate[this.tree_type];
        const tag = this.tags.find((t) => t.key === 'tree_type');
        if (tag) {
          tag.name = treeName;
        } else if (this.tree_type !== 'full') {
          this.tags.push({ name: treeName, key: 'tree_type' });
        }
      }
      // Номер агента
      if (this.filterData.agent_id !== null
      && this.filterData.agent_id !== ''
      && this.filterData.agent_id !== undefined) {
        const tag = this.tags.find((t) => t.key === 'agent_id');
        if (tag) {
          tag.name = `Номер агента: ${this.filterData.agent_id}`;
        } else {
          this.tags.push({ name: `Номер агента: ${this.filterData.agent_id}`, key: 'agent_id' });
        }
      } else if (this.tags.find((t) => t.key === 'agent_id')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'agent_id')), 1);
      }
      // ФИО
      if (this.filterData.fullname !== null
      && this.filterData.fullname !== ''
      && this.filterData.fullname !== undefined) {
        const tag = this.tags.find((t) => t.key === 'fullname');
        if (tag) {
          tag.name = `ФИО: ${this.filterData.fullname}`;
        } else {
          this.tags.push({ name: `ФИО: ${this.filterData.fullname}`, key: 'fullname' });
        }
      } else if (this.tags.find((t) => t.key === 'fullname')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'fullname')), 1);
      }
      // Город склада обслуживания
      if (this.filterData.store !== null
      && this.filterData.store !== ''
      && this.filterData.store !== undefined) {
        const tag = this.tags.find((t) => t.key === 'store');
        if (tag) {
          tag.name = `Город склада обслуживания: ${this.filterData.store}`;
        } else {
          this.tags.push({ name: `Город склада обслуживания: ${this.filterData.store}`, key: 'store' });
        }
      } else if (this.tags.find((t) => t.key === 'store')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'store')), 1);
      }
      // Ранг на начало
      if (this.filterData.rank_beg !== null
      && this.filterData.rank_beg !== ''
      && this.filterData.rank_beg !== undefined) {
        const tag = this.tags.find((t) => t.key === 'rank_beg');
        if (tag) {
          tag.name = `Ранг на начало: ${this.filterData.rank_beg}`;
        } else {
          this.tags.push({ name: `Ранг на начало: ${this.filterData.rank_beg}`, key: 'rank_beg' });
        }
      } else if (this.tags.find((t) => t.key === 'rank_beg')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'rank_beg')), 1);
      }
      // Ранг на конец
      if (this.filterData.rank_end !== null
      && this.filterData.rank_end !== ''
      && this.filterData.rank_end !== undefined) {
        const tag = this.tags.find((t) => t.key === 'rank_end');
        if (tag) {
          tag.name = `Ранг на конец: ${this.filterData.rank_end}`;
        } else {
          this.tags.push({ name: `Ранг на конец: ${this.filterData.rank_end}`, key: 'rank_end' });
        }
      } else if (this.tags.find((t) => t.key === 'rank_end')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'rank_end')), 1);
      }
      // Рассчетный ранг
      if (this.filterData.rank_calc !== null
      && this.filterData.rank_calc !== ''
      && this.filterData.rank_calc !== undefined) {
        const tag = this.tags.find((t) => t.key === 'rank_calc');
        if (tag) {
          tag.name = `Рассчетный ранг: ${this.filterData.rank_calc}`;
        } else {
          this.tags.push({ name: `Рассчетный ранг: ${this.filterData.rank_calc}`, key: 'rank_calc' });
        }
      } else if (this.tags.find((t) => t.key === 'rank_calc')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'rank_calc')), 1);
      }
      // Территория
      if (this.filterData.area_id !== null
      && this.filterData.area_id !== ''
      && this.filterData.area_id !== undefined) {
        const tag = this.tags.find((t) => t.key === 'area_id');
        if (tag) {
          console.log('area 1');
          tag.name = `Территория: ${this.areaList.find((area) => area.area_id === this.filterData.area_id).area_name}`;
        } else {
          console.log('area 2');
          this.tags.push({ name: `Территория: ${this.areaList.find((area) => area.area_id === this.filterData.area_id).area_name}`, key: 'area_id' });
        }
      } else if (this.tags.find((t) => t.key === 'area_id')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'area_id')), 1);
      }
      // Показывать терменированных
      if (this.filterData.status) {
        const tag = this.tags.find((t) => t.key === 'status');
        if (tag) {
          tag.name = 'Показывать терминированных';
        } else {
          this.tags.push({ name: 'Показывать терминированных', key: 'status' });
        }
      } else if (this.tags.find((t) => t.key === 'status')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'status')), 1);
      }
      // Фильтр по ЛО
      const tag = this.tags.find((t) => t.key === 'lo_type');
      if (tag) {
        tag.name = `ЛО: ${this.lo_types[String(this.lo_type)]}`;
      } else {
        this.tags.push({ name: `ЛО: ${this.lo_types[String(this.lo_type)]}`, key: 'lo_type' });
      }
      // Фильтр по Резерву
      const reservetag = this.tags.find((t) => t.key === 'reserve_type');
      if (reservetag) {
        reservetag.name = `Резерв: ${this.reserve_types[String(this.reserve_type)]}`;
      } else {
        this.tags.push({ name: `Резерв: ${this.reserve_types[String(this.reserve_type)]}`, key: 'reserve_type' });
      }
      this.searchActive = false;
      backApi.get('/agent/flat_genealogy', data)
        .then((Response) => {
          Response.data.entries.forEach((r) => {
            r.transfer = r.lo;
            if (r.is_can_transfer) {
              this.entriesCache.set(r, r.transfer);
            }
          });
          this.entries = Response.data.entries;
          this.clearAll();
          this.setData(this.entries);
          this.infiniteId += 1;
          this.loading = false;
        });
    },
    setDefaultFields() {
      this.fields = [
        {
          key: 'id',
          label: this.$t('P/номер / Ранг'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
          thClass: 'fsth',
        },
        {
          key: 'name',
          label: this.$t('ФИО'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
        },
        {
          key: 'noact',
          label: this.$t('Неакт.'),
          formater: (item) => item.noact,
          sortable: true,
        },
        {
          key: 'reserve',
          label: this.$t('Резерв'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        // {
        //   key: 'trans',
        //   label: 'Трансферт',
        // },
        {
          key: 'lo',
          label: this.$t('Итого ЛО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'transfer_only',
          label: this.$t('Трансферт из НС'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'external_lo',
          label: this.$t('Внешний трансферт'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'go',
          label: this.$t('ГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ngo',
          label: this.$t('НГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'oo',
          label: this.$t('ОО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ko',
          label: this.$t('КО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        // {
        //   key: 'proportional',
        //   label: this.$t('Выполнение Пропорц. %'),
        //   formater: (item) => item.noact,
        //   sortable: true,
        // },
        // {
        //   key: 'rank_beg_npp',
        //   label: this.$t('Ранг на начало'),
        //   formater: (item) => item.rank_beg,
        //   sortable: true,
        // },
        {
          key: 'rank_calc_npp',
          label: this.$t('Расчетный ранг'),
          formater: (item) => item.rank_calc,
          sortable: true,
        },
        // {
        //   key: 'rank_end_npp',
        //   label: this.$t('Ранг на конец'),
        //   sortable: true,
        // },
        {
          key: 'cityname',
          label: this.$t('Город'),
          formater: (item) => item.cityname,
          sortable: true,
        },
        {
          key: 'areaname',
          label: this.$t('Территория'),
          formater: (item) => item.areaname,
          sortable: true,
        },
        {
          key: 'isterminated',
          label: this.$t('Терм.'),
          // formatter: (item) => {
          //   if (item.isterminated === 0) {
          //     return 'Нет';
          //   }
          //   return 'Да';
          // },
          sortable: true,
        },
      ];
    },
    nextPeriod(x) {
      this.showGoDetails = false;
      this.periodIndex = (this.periodIndex + this.periods.length + x) % this.periods.length;
    },
    ...mapActions('currentPage', ['setPageTitle']),
    clearRegion() {
      this.filterData.area_id = null;
    },
    print() {
      const colGroup1 = document.getElementsByTagName('colgroup')[0];
      const colGroup2 = document.getElementsByTagName('colgroup')[1];
      colGroup1.style.display = 'none';
      colGroup2.style.display = 'none';
      const tableHead = document.querySelector('.el-table__header');
      const tableBody = document.querySelector('.el-table__body');
      const hashWH = tableHead.style.width;
      const hashWB = tableBody.style.width;
      console.log(hashWH, hashWB);
      tableHead.style.width = '920px';
      tableBody.style.width = '920px';
      window.print();
      setTimeout(() => {
        colGroup1.style.display = 'block';
        colGroup2.style.display = 'block';
        tableHead.style.width = hashWH;
        tableBody.style.width = hashWB;
      });
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
      this.selectedRow = null;
    },
    async handleCurrentChange(val) {
      this.selectedRow = val;
      console.log(val);
      this.showTrans = false;
      if (val) {
        await backApi.get('/agent/transfer-info', { params: { another_agent_id: val.id } })
          .then(() => {
            this.id = val.id;
            this.transAccess = false;
          })
          .catch(() => {
            this.transAccess = true;
          });
        await backApi.get(`/agent/transfert-property/${val.id}`, { params: { comdte: this.periods[this.periodIndex].period } })
          .then((Response) => {
            this.selectedRowAgentInfo = Response.data;
          })
          .catch(() => {
          });
      } else {
        this.transAccess = true;
      }
    },
    // eslint-disable-next-line consistent-return
    colMinWidth(key) {
      if (key === 'id') return 120;
      if (key === 'name') return 300;
      if (key === 'go' || key === 'ngo' || key === 'so' || key === 'ko' || key === 'lo') return 70;
      if (key === 'transfer_only') return 70;
      if (key === 'external_lo') return 70;
      if (key === 'discount_pc') return 80;
      if (key === 'noact') return 100;
      // eslint-disable-next-line consistent-return
    },
    // eslint-disable-next-line consistent-return
    colWidth(key) {
      if (key === 'id') return 130;
      if (key === 'rang_icon') return 45;
      if (key === 'reserve' || key === 'ngo' || key === 'oo' || key === 'ko') return 100;
      if (key === 'go' || key === 'so') return 80;
      if (key === 'rank_calc_npp') return 160;
      if (key === 'noact') return 70;
      if (key === 'transfer_only' || key === 'external_lo' || key === 'lo') return 80;
      if (key === 'isterminated') return 50;
      if (key === 'areaname') return 80;
      if (key === 'cityname') return 140;
      // eslint-disable-next-line consistent-return
    },
    ...mapActions('transStore', ['setData', 'setAllDefault', 'setDefault', 'clearAll', 'updateUserTransfertData']),
    clearTranfer(evt, id) {
      this.setDefault(id);
      evt.stopPropagation();
    },
    massTranseftAction() {
      this.massTranseftEdit = true;
      this.fields = [
        {
          key: 'id',
          label: this.$t('P/номер / Ранг'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
          thClass: 'fsth',
        },
        {
          key: 'name',
          label: this.$t('ФИО'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
        },
        {
          key: 'noact',
          label: this.$t('Неакт.'),
          formater: (item) => item.noact,
          sortable: true,
        },
        {
          key: 'reserve',
          label: this.$t('Резерв'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'trans',
          label: this.$t('Трансферт'),
        },
        {
          key: 'lo',
          label: this.$t('Итого ЛО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'transfer_only',
          label: this.$t('Трансферт из НС'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'external_lo',
          label: this.$t('Внешний трансферт'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'go',
          label: this.$t('ГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ngo',
          label: this.$t('НГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'oo',
          label: this.$t('ОО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ko',
          label: this.$t('КО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        // {
        //   key: 'proportional',
        //   label: this.$t('Выполнение Пропорц. %'),
        //   formater: (item) => item.noact,
        //   sortable: true,
        // },
        // {
        //   key: 'rank_beg_npp',
        //   label: this.$t('Ранг на начало'),
        //   formater: (item) => item.rank_beg,
        //   sortable: true,
        // },
        {
          key: 'rank_calc_npp',
          label: this.$t('Расчетный ранг'),
          formater: (item) => item.rank_calc,
          sortable: true,
        },
        // {
        //   key: 'rank_end_npp',
        //   label: this.$t('Ранг на конец'),
        //   sortable: true,
        // },
        {
          key: 'cityname',
          label: this.$t('Город'),
          formater: (item) => item.cityname,
          sortable: true,
        },
        {
          key: 'areaname',
          label: this.$t('Территория'),
          formater: (item) => item.areaname,
          sortable: true,
        },
        {
          key: 'isterminated',
          label: this.$t('Терм.'),
          // formatter: (item) => {
          //   if (item.isterminated === 0) {
          //     return 'Нет';
          //   }
          //   return 'Да';
          // },
          sortable: true,
        },
      ];
    },
    cancelTransfer() {
      this.massTranseftEdit = false;
      this.fields = [
        {
          key: 'id',
          label: this.$t('P/номер / Ранг'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
          thClass: 'fsth',
        },
        {
          key: 'name',
          label: this.$t('ФИО'),
          formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
        },
        {
          key: 'noact',
          label: this.$t('Неакт.'),
          formater: (item) => item.noact,
          sortable: true,
        },
        {
          key: 'reserve',
          label: this.$t('Резерв'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        // {
        //   key: 'trans',
        //   label: 'Трансферт',
        // },
        {
          key: 'lo',
          label: this.$t('Итого ЛО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'transfer_only',
          label: this.$t('Трансферт из НС'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'external_lo',
          label: this.$t('Внешний трансферт'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'go',
          label: this.$t('ГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ngo',
          label: this.$t('НГО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'oo',
          label: this.$t('ОО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        {
          key: 'ko',
          label: this.$t('КО'),
          formatter: (v) => {
            const formatter = new Intl.NumberFormat('ru');
            return formatter.format(v);
          },
          sortable: true,
        },
        // {
        //   key: 'proportional',
        //   label: this.$t('Выполнение Пропорц. %'),
        //   formater: (item) => item.noact,
        //   sortable: true,
        // },
        // {
        //   key: 'rank_beg_npp',
        //   label: this.$t('Ранг на начало'),
        //   formater: (item) => item.rank_beg,
        //   sortable: true,
        // },
        {
          key: 'rank_calc_npp',
          label: this.$t('Расчетный ранг'),
          formater: (item) => item.rank_calc,
          sortable: true,
        },
        // {
        //   key: 'rank_end_npp',
        //   label: this.$t('Ранг на конец'),
        //   sortable: true,
        // },
        {
          key: 'cityname',
          label: this.$t('Город'),
          formater: (item) => item.cityname,
          sortable: true,
        },
        {
          key: 'areaname',
          label: this.$t('Территория'),
          formater: (item) => item.areaname,
          sortable: true,
        },
        {
          key: 'isterminated',
          label: this.$t('Терм.'),
          // formatter: (item) => {
          //   if (item.isterminated === 0) {
          //     return 'Нет';
          //   }
          //   return 'Да';
          // },
          sortable: true,
        },
      ];
      this.setAllDefault();
      this.setCurrent();
    },
    async makeAllTransfer() {
      // const errorMass = Array.from(document.getElementsByClassName('error'));
      // const transMass = Array.from(document.getElementsByClassName('changed'));
      const res = await this.createMessageBox('Вы уверены?', this.getErrorMulti);
      if (res) {
        this.loading = true;
        // eslint-disable-next-line no-restricted-syntax
        for (const val of this.getReadyMulti) {
          // eslint-disable-next-line no-await-in-loop
          await backApi.post(`/agent/transfer-lo/${val.id}`, {
            lo: val.transData.transfert,
          }).catch((error) => {
            this.createMessageBoxError(this.$t(error.response.data.detail));
          });
        }
        this.offset = 0;
        this.count = 15;
        this.entries = [];
        this.clearAll();
        this.massTranseftEdit = false;
        this.fields = [
          {
            key: 'id',
            label: this.$t('P/номер / Ранг'),
            formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
            thClass: 'fsth',
          },
          {
            key: 'name',
            label: this.$t('ФИО'),
            formater: (item) => `УР ${item.depth}<br>${item.rank_beg}<br>${item.id}<br>${item.name}`,
          },
          {
            key: 'noact',
            label: this.$t('Неакт.'),
            formater: (item) => item.noact,
            sortable: true,
          },
          {
            key: 'reserve',
            label: this.$t('Резерв'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          // {
          //   key: 'trans',
          //   label: 'Трансферт',
          // },
          {
            key: 'lo',
            label: this.$t('Итого ЛО'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          {
            key: 'transfer_only',
            label: this.$t('Трансферт из НС'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          {
            key: 'external_lo',
            label: this.$t('Внешний трансферт'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          {
            key: 'go',
            label: this.$t('ГО'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          {
            key: 'ngo',
            label: this.$t('НГО'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          {
            key: 'oo',
            label: this.$t('ОО'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          {
            key: 'ko',
            label: this.$t('КО'),
            formatter: (v) => {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            },
            sortable: true,
          },
          // {
          //   key: 'proportional',
          //   label: this.$t('Выполнение Пропорц. %'),
          //   formater: (item) => item.noact,
          //   sortable: true,
          // },
          // {
          //   key: 'rank_beg_npp',
          //   label: this.$t('Ранг на начало'),
          //   formater: (item) => item.rank_beg,
          //   sortable: true,
          // },
          {
            key: 'rank_calc_npp',
            label: this.$t('Расчетный ранг'),
            formater: (item) => item.rank_calc,
            sortable: true,
          },
          // {
          //   key: 'rank_end_npp',
          //   label: this.$t('Ранг на конец'),
          //   sortable: true,
          // },
          {
            key: 'cityname',
            label: this.$t('Город'),
            formater: (item) => item.cityname,
            sortable: true,
          },
          {
            key: 'areaname',
            label: this.$t('Территория'),
            formater: (item) => item.areaname,
            sortable: true,
          },
          {
            key: 'isterminated',
            label: this.$t('Терм.'),
            // formatter: (item) => {
            //   if (item.isterminated === 0) {
            //     return 'Нет';
            //   }
            //   return 'Да';
            // },
            sortable: true,
          },
        ];
        this.loading = false;
        // this.$refs.infinit.$listeners.infinite();
        this.infiniteId += 1;
        // this.$router.go(0);
        // await this.updateData();
        // await this.createMessageBoxError('Операция выполнена успешно');
      }
    },
    dd() {
      this.entries = [];
      this.massTranseftEdit = false;
      this.setDefaultFields();
      this.loading = true;
      backApi.get('/agent/profile').then((Response) => {
        this.currentUserId = Response.data.id;
        this.state = `${Response.data.id} - ${Response.data.name}`;
        this.updateData();
        // backApi.get('/agent/flat_genealogy', {
        //   params: {
        //     comdte: this.periods[this.periodIndex].period,
        //     agent_id: Response.data.id,
        //     tree_type: this.tree_type,
        //     // eslint-disable-next-line radix
        //     with_terminated: parseInt(this.filterData.status),
        //     offset: 0,
        //     count: Number(this.count),
        //     sub_agent_id: this.currentSubUserId,
        //   },
        // }).then((Response2) => {
        //   this.entries = Response2.data.entries;
        //   this.loading = false;
        // });
      });
    },
    dd2() {
      this.entries = [];
      this.massTranseftEdit = false;
      this.setDefaultFields();
      this.loading = true;
      this.currentSubUserId = null;
      this.substate = '';
      this.updateData();
      // backApi.get('/agent/profile').then((Response) => {
      //   backApi.get('/agent/flat_genealogy', {
      //     params: {
      //       comdte: this.periods[this.periodIndex].period,
      //       agent_id: Response.data.id,
      //       tree_type: this.tree_type,
      //       // eslint-disable-next-line radix
      //       with_terminated: parseInt(this.filterData.status),
      //       offset: 0,
      //       count: Number(this.count),
      //       sub_agent_id: this.currentSubUserId,
      //     },
      //   }).then((Response2) => {
      //     this.entries = Response2.data.entries;
      //     this.loading = false;
      //   });
      // });
    },
    querySearchAsync(queryString, cb) {
      backApi.get('/agent/share-transfert-list', { params: { show_root: 1 } }).then((Response2) => {
        Response2.data.entries.forEach((u) => {
          // eslint-disable-next-line no-param-reassign
          u.value = `${u.id}-${u.agentname}`;
        });
        cb(Response2.data.entries.slice(0, 10));
      });
    },
    querySearchAsync2(queryString, cb) {
      backApi.get('/agent/agents-by-context', { params: { context_id: this.currentUserId, find_str: queryString, comdte: this.currentPeriod } }).then((Response2) => {
        Response2.data.entries.forEach((u) => {
          // eslint-disable-next-line no-param-reassign
          u.value = `${u.agent_id}-${u.agent_name}`;
        });
        cb(Response2.data.entries.slice(0, 10));
      });
    },
    handleSelect(item) {
      this.entries = [];
      this.massTranseftEdit = false;
      this.setDefaultFields();
      this.loading = true;
      this.currentUserId = item.id;
      backApi.get('/agent/flat_genealogy', {
        params: {
          comdte: this.periods[this.periodIndex].period,
          agent_id: item.id,
          tree_type: this.tree_type,
          // eslint-disable-next-line radix
          with_terminated: parseInt(this.filterData.status),
          offset: 0,
          count: Number(this.count),
          sub_agent_id: null,
        },
      }).then((Response2) => {
        Response2.data.entries.forEach((r) => {
          r.transfer = r.lo;
          if (r.is_can_transfer) {
            this.entriesCache.set(r, r.transfer);
          }
        });
        this.entries = Response2.data.entries;
        this.setData(this.entries);
        this.infiniteId += 1;
        this.loading = false;
      });
    },
    handleSelect2() {
      this.entries = [];
      this.massTranseftEdit = false;
      this.setDefaultFields();
      this.loading = true;
      this.substate = `${this.selectedRow.id} - ${this.selectedRow.name}`;
      this.currentSubUser = this.selectedRow;
      this.currentSubUserId = this.selectedRow.id;
      this.updateData();
    },
    handleSelect3(item) {
      this.entries = [];
      this.massTranseftEdit = false;
      this.setDefaultFields();
      this.loading = true;
      this.substate = `${item.agent_id} - ${item.agent_name}`;
      this.currentSubUser = this.item;
      this.currentSubUserId = item.agent_id;
      this.updateData();
    },
    showToast(title, message, status) {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      // Increment the toast count
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        h('strong', { class: 'mr-2' }, message),
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h('strong', { class: 'mr-2' }, title),
        ],
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: status,
      });
    },
    createMessageBox(messageText, arr = []) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] },
        [
          h('h3', { class: ['text-center'] },
            [
              messageText,
              arr.length > 0 ? arr.map((e) => h('p', { class: ['modal_p', 'error'] }, [`${this.$t('Превышен лимит у')} ${e.id}`])) : '',
              arr.length > 0 ? h('p', { class: ['modal_p'] }, [`${this.$t('Всё равно продолжить?')}`]) : '',
            ]),
        ]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        buttonSize: 'md',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'Да',
        size: 'xl',
      });
    },
    createMessageBoxInfo(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('h5', { class: ['text-center'] }, [messageText]),
      ]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxOk([messageVNode], {
        buttonSize: 'xl',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'OK',
        size: 'md',
      });
    },
    onRowSelected(item) {
      this.showTrans = false;
      if (item.length > 0) {
        backApi.get('/agent/transfer-info', { params: { another_agent_id: item[0].id } })
          .then(() => {
            this.id = item[0].id;
            this.transAccess = false;
          })
          .catch(() => {
            this.transAccess = true;
          });
      } else {
        this.transAccess = true;
      }
    },
    rowClass(item) {
      if (item.lvl === '0') {
        return 'green';
      }
      return `depth-${item.lvl}`;
    },
    tableRowClassName({ row }) {
      return `depth-${row.lvl} ${row.is_can_transfer ? 'can_trans' : ''} userid-${row.id}`;
    },
    handleClose(event, tag) {
      this.entries = [];
      if (tag.key === 'rank_beg') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.rank_beg = null;
        this.updateData();
      }
      if (tag.key === 'rank_calc') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.rank_calc = null;
        this.updateData();
      }
      if (tag.key === 'rank_end') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.rank_end = null;
        this.updateData();
      }
      if (tag.key === 'area_id') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.area_id = null;
        this.updateData();
      }
      if (tag.key === 'agent_id') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.agent_id = null;
        this.updateData();
      }
      if (tag.key === 'fullname') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.fullname = null;
        this.updateData();
      }
      if (tag.key === 'store') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.store = null;
        this.updateData();
      }
      if (tag.key === 'currentSubUserId') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.sub_agent_id = null;
        this.currentSubUser = null;
        this.currentSubUserId = null;
        this.updateData();
      }
      if (tag.key === 'status') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.filterData.status = 0;
        this.updateData();
      }
      if (tag.key === 'lo_type') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.lo_type = 3;
        this.updateData();
      }
      if (tag.key === 'reserve_type') {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.reserve_type = 3;
        this.updateData();
      }
      if (tag.key === 'tree_type') {
        if (tag.name !== 'Полное дерево') {
          this.tree_type = 0;
          this.updateData();
        }
      }
    },
    clearInput(name) {
      this.filterData[name] = null;
    },
    downloadXls() {
      const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
      const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

      const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
      const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

      const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
      const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

      const areaName = this.areaList.find((a) => a.area_id === this.filterData.area_id)
        ? this.areaList.find((a) => a.area_id === this.filterData.area_id).area_name : null;

      const dataa = {
        params: {
          context: this.currentUserId,
          // eslint-disable-next-line radix
          with_terminated: parseInt(this.filterData.status),
          tree_type: this.tree_type,
          num: this.filterData.agent_id,
          fullname: this.filterData.fullname,
          area_name: areaName,
          area_id: this.filterData.area_id,
          city: this.filterData.store,
          rank_beg_name: this.filterData.rank_beg,
          i_rank_beg: rankBeg,
          i_status_beg: statusBeg,
          rank_calc_name: this.filterData.rank_calc,
          i_rank_calc: rankCalc,
          i_status_calc: statusCalc,
          rank_end_name: this.filterData.rank_end,
          i_rank_end: rankEnd,
          i_lo: this.lo_type,
          i_reserve: this.reserve_type,
          comdte: this.periods[this.periodIndex].period,
          i_status_end: statusEnd,
          sub_agent_id: this.currentSubUserId,
        },
        responseType: 'blob',
      };
      backApi.get('/agent/flat_genealogy/excel', dataa)
        .then(({ data }) => {
          const filename = `${this.$t('Управление трансфертами структуры')}.xlsx`;
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    downloadPdf() {
      const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
      const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

      const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
      const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

      const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
      const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

      const areaName = this.areaList.find((a) => a.area_id === this.filterData.area_id)
        ? this.areaList.find((a) => a.area_id === this.filterData.area_id).area_name : null;

      const dataa = {
        params: {
          comdte: this.periods[this.periodIndex].period,
          context: this.currentUserId,
          // eslint-disable-next-line radix
          with_terminated: parseInt(this.filterData.status),
          tree_type: this.tree_type,
          num: this.filterData.agent_id,
          fullname: this.filterData.fullname,
          area_id: this.filterData.area_id,
          area_name: areaName,
          city: this.filterData.store,
          rank_beg_name: this.filterData.rank_beg,
          i_rank_beg: rankBeg,
          i_status_beg: statusBeg,
          rank_calc_name: this.filterData.rank_calc,
          i_rank_calc: rankCalc,
          i_status_calc: statusCalc,
          rank_end_name: this.filterData.rank_end,
          i_rank_end: rankEnd,
          i_status_end: statusEnd,
          i_lo: this.lo_type,
          i_reserve: this.reserve_type,
          sub_agent_id: this.currentSubUserId,
        },
        responseType: 'blob',
      };
      backApi.get('/agent/flat_genealogy/pdf', dataa)
        .then(({ data }) => {
          const filename = `${this.$t('Управление трансфертами структуры')}.pdf`;
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    async updateData() {
      this.loading = true;
      const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
      const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

      const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
      const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

      const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
      const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
        ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

      const data = {
        params: {
          // eslint-disable-next-line radix
          with_terminated: parseInt(this.filterData.status),
          comdte: this.periods[this.periodIndex].period,
          tree_type: this.tree_type,
          agent_id: this.currentUserId,
          num: this.filterData.agent_id,
          fullname: this.filterData.fullname,
          area_id: this.filterData.area_id,
          city: this.filterData.store,
          i_rank_beg: rankBeg,
          i_status_beg: statusBeg,
          i_rank_calc: rankCalc,
          i_status_calc: statusCalc,
          i_rank_end: rankEnd,
          i_status_end: statusEnd,
          i_lo: this.lo_type,
          i_reserve: this.reserve_type,
          offset: 0,
          count: Number(this.count),
          sub_agent_id: this.currentSubUserId,
        },
      };
      const treeNameTranslate = {
        2: 'Личная группа',
        0: 'Полное дерево',
        1: 'Директорское',
      };
      // Тип дерева
      if (this.tree_type !== null) {
        const treeName = treeNameTranslate[this.tree_type];
        const tag = this.tags.find((t) => t.key === 'tree_type');
        if (tag) {
          tag.name = treeName;
        } else if (this.tree_type !== 'full') {
          this.tags.push({ name: treeName, key: 'tree_type' });
        }
      }
      // Номер агента
      if (this.filterData.agent_id !== null
      && this.filterData.agent_id !== ''
      && this.filterData.agent_id !== undefined) {
        const tag = this.tags.find((t) => t.key === 'agent_id');
        if (tag) {
          tag.name = `Номер агента: ${this.filterData.agent_id}`;
        } else {
          this.tags.push({ name: `Номер агента: ${this.filterData.agent_id}`, key: 'agent_id' });
        }
      } else if (this.tags.find((t) => t.key === 'agent_id')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'agent_id')), 1);
      }
      // ФИО
      if (this.filterData.fullname !== null
      && this.filterData.fullname !== ''
      && this.filterData.fullname !== undefined) {
        const tag = this.tags.find((t) => t.key === 'fullname');
        if (tag) {
          tag.name = `ФИО: ${this.filterData.fullname}`;
        } else {
          this.tags.push({ name: `ФИО: ${this.filterData.fullname}`, key: 'fullname' });
        }
      } else if (this.tags.find((t) => t.key === 'fullname')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'fullname')), 1);
      }
      // Город склада обслуживания
      if (this.filterData.store !== null
      && this.filterData.store !== ''
      && this.filterData.store !== undefined) {
        const tag = this.tags.find((t) => t.key === 'store');
        if (tag) {
          tag.name = `Город склада обслуживания: ${this.filterData.store}`;
        } else {
          this.tags.push({ name: `Город склада обслуживания: ${this.filterData.store}`, key: 'store' });
        }
      } else if (this.tags.find((t) => t.key === 'store')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'store')), 1);
      }
      // Ранг на начало
      if (this.filterData.rank_beg !== null
      && this.filterData.rank_beg !== ''
      && this.filterData.rank_beg !== undefined) {
        const tag = this.tags.find((t) => t.key === 'rank_beg');
        if (tag) {
          tag.name = `Ранг на начало: ${this.filterData.rank_beg}`;
        } else {
          this.tags.push({ name: `Ранг на начало: ${this.filterData.rank_beg}`, key: 'rank_beg' });
        }
      } else if (this.tags.find((t) => t.key === 'rank_beg')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'rank_beg')), 1);
      }
      // Ранг на конец
      if (this.filterData.rank_end !== null
      && this.filterData.rank_end !== ''
      && this.filterData.rank_end !== undefined) {
        const tag = this.tags.find((t) => t.key === 'rank_end');
        if (tag) {
          tag.name = `Ранг на конец: ${this.filterData.rank_end}`;
        } else {
          this.tags.push({ name: `Ранг на конец: ${this.filterData.rank_end}`, key: 'rank_end' });
        }
      } else if (this.tags.find((t) => t.key === 'rank_end')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'rank_end')), 1);
      }
      // Рассчетный ранг
      if (this.filterData.rank_calc !== null
      && this.filterData.rank_calc !== ''
      && this.filterData.rank_calc !== undefined) {
        const tag = this.tags.find((t) => t.key === 'rank_calc');
        if (tag) {
          tag.name = `Рассчетный ранг: ${this.filterData.rank_calc}`;
        } else {
          this.tags.push({ name: `Рассчетный ранг: ${this.filterData.rank_calc}`, key: 'rank_calc' });
        }
      } else if (this.tags.find((t) => t.key === 'rank_calc')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'rank_calc')), 1);
      }
      // Территория
      if (this.filterData.area_id !== null
      && this.filterData.area_id !== ''
      && this.filterData.area_id !== undefined) {
        const tag = this.tags.find((t) => t.key === 'area_id');
        if (tag) {
          console.log('area 1');
          tag.name = `Территория: ${this.areaList.find((area) => area.area_id === this.filterData.area_id).area_name}`;
        } else {
          console.log('area 2');
          this.tags.push({ name: `Территория: ${this.areaList.find((area) => area.area_id === this.filterData.area_id).area_name}`, key: 'area_id' });
        }
      } else if (this.tags.find((t) => t.key === 'area_id')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'area_id')), 1);
      }
      // // Контекст
      // if (this.currentSubUserId !== '' && this.currentSubUserId !== null) {
      //   const tag = this.tags.find((t) => t.key === 'currentSubUserId');
      //   if (tag) {
      //     tag.name = `Контекст: ${this.currentSubUser.name}`;
      //   } else {
      //     this.tags.push({ name: `Контекст: ${this.currentSubUser.name}`, key: 'currentSubUserId' });
      //   }
      // } else if (this.tags.find((t) => t.key === 'currentSubUserId')) {
      //   this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'currentSubUserId')), 1);
      // }
      // Показывать терменированных
      if (this.filterData.status) {
        const tag = this.tags.find((t) => t.key === 'status');
        if (tag) {
          tag.name = 'Показывать терминированных';
        } else {
          this.tags.push({ name: 'Показывать терминированных', key: 'status' });
        }
      } else if (this.tags.find((t) => t.key === 'status')) {
        this.tags.splice(this.tags.indexOf(this.tags.find((t) => t.key === 'status')), 1);
      }
      // Фильтр по ЛО
      const lotag = this.tags.find((t) => t.key === 'lo_type');
      if (lotag) {
        lotag.name = `ЛО: ${this.lo_types[String(this.lo_type)]}`;
      } else {
        this.tags.push({ name: `ЛО: ${this.lo_types[String(this.lo_type)]}`, key: 'lo_type' });
      }
      // Фильтр по Резерву
      const reservetag = this.tags.find((t) => t.key === 'reserve_type');
      if (reservetag) {
        reservetag.name = `Резерв: ${this.reserve_types[String(this.reserve_type)]}`;
      } else {
        this.tags.push({ name: `Резерв: ${this.reserve_types[String(this.reserve_type)]}`, key: 'reserve_type' });
      }
      this.searchActive = false;
      backApi.get('/agent/flat_genealogy', data)
        .then((Response) => {
          console.log('1111');
          Response.data.entries.forEach((r) => {
            r.transfer = r.lo;
            if (r.is_can_transfer) {
              this.entriesCache.set(r, r.transfer);
            }
          });
          this.entries = Response.data.entries;
          this.setData(this.entries);
          this.infiniteId += 1;
          this.loading = false;
          this.$nextTick(() => {
            setTimeout(() => {
              document.querySelector('.el-table__body-wrapper').scrollTop = 0;
            }, 100);
          });
        });
    },
    resetData() {
      this.filterData = { status: 1 };
      this.tags = [];
      this.tree_type = 2;
      this.lo_type = 3;
      this.reserve_type = 3;
      this.entries = [];
      this.updateData();
    },
    back() {
      const navEl = document.getElementsByClassName('router-link-exact-active router-link-active');
      $(navEl[0])
        .parent()
        .parent()
        .siblings()
        .addClass('active');
    },
    infiniteHandler($state) {
      backApi.get('/agent/rank-list').then((Response) => {
        this.rankList = Response.data.entries;
      });
      backApi.get('/agent/area-list').then((Response) => {
        this.areaList = Response.data.entries;
      });
      if (this.$route.params.id) {
        backApi.get('agent/share-transfert-list', { params: { show_root: 1 } }).then((Response) => {
          // eslint-disable-next-line eqeqeq
          const user = Response.data.entries.filter((u) => u.id == this.$route.params.id);
          if (this.state === '') {
            this.state = `${user[0].id} - ${user[0].agentname}`;
            this.currentUserId = user[0].id;
          }
        });
        const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
        const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

        const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
        const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

        const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
        const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
          ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

        const data = {
          params: {
            // eslint-disable-next-line radix
            with_terminated: parseInt(this.filterData.status),
            comdte: this.periods[this.periodIndex].period,
            tree_type: this.tree_type,
            agent_id: this.currentUserId,
            num: this.filterData.agent_id,
            fullname: this.filterData.fullname,
            area_id: this.filterData.area_id,
            city: this.filterData.store,
            i_rank_beg: rankBeg,
            i_status_beg: statusBeg,
            i_rank_calc: rankCalc,
            i_status_calc: statusCalc,
            i_rank_end: rankEnd,
            i_status_end: statusEnd,
            i_lo: this.lo_type,
            i_reserve: this.reserve_type,
            offset: Number(this.entries.length),
            count: Number(this.count),
            sub_agent_id: this.currentSubUserId,
          },
        };
        backApi.get('/agent/flat_genealogy', data).then((Response) => {
          console.log('1');
          Response.data.entries.forEach((r) => {
            r.transfer = r.lo;
            if (r.is_can_transfer) {
              this.entriesCache.set(r, r.transfer);
            }
          });
          this.entries = Response.data.entries;
          this.loading = false;
          this.setData(this.entries);
          $state.loaded();
        });
        const treeNameTranslate = {
          2: 'Личная группа',
          0: 'Полное дерево',
          1: 'Директорское',
        };
        if (this.tree_type !== null) {
          const treeName = treeNameTranslate[this.tree_type];
          const tag = this.tags.find((t) => t.key === 'tree_type');
          if (tag) {
            tag.name = treeName;
          } else if (this.tree_type !== 'full') {
            this.tags.push({ name: treeName, key: 'tree_type' });
          }
        }
      } else {
        backApi.get('/agent/profile').then((Response) => {
          if (this.state === '') {
            this.state = `${Response.data.id} - ${Response.data.name}`;
            this.currentUserId = Response.data.id;
          }
          const rankBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
            ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_rank : null;
          const statusBeg = this.rankList.find((i) => i.rankname === this.filterData.rank_beg)
            ? this.rankList.find((i) => i.rankname === this.filterData.rank_beg).i_status : null;

          const rankCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
            ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_rank : null;
          const statusCalc = this.rankList.find((i) => i.rankname === this.filterData.rank_calc)
            ? this.rankList.find((i) => i.rankname === this.filterData.rank_calc).i_status : null;

          const rankEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
            ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_rank : null;
          const statusEnd = this.rankList.find((i) => i.rankname === this.filterData.rank_end)
            ? this.rankList.find((i) => i.rankname === this.filterData.rank_end).i_status : null;

          console.log(this.entries.length);

          const data = {
            params: {
              comdte: this.periods[this.periodIndex].period,
              // eslint-disable-next-line radix
              with_terminated: parseInt(this.filterData.status),
              tree_type: this.tree_type,
              agent_id: this.currentUserId,
              num: this.filterData.agent_id,
              fullname: this.filterData.fullname,
              area_id: this.filterData.area_id,
              city: this.filterData.store,
              i_rank_beg: rankBeg,
              i_status_beg: statusBeg,
              i_rank_calc: rankCalc,
              i_status_calc: statusCalc,
              i_rank_end: rankEnd,
              i_status_end: statusEnd,
              i_lo: this.lo_type,
              i_reserve: this.reserve_type,
              offset: Number(this.entries.length),
              count: Number(this.count),
              sub_agent_id: this.currentSubUserId,
            },
          };
          backApi.get('/agent/flat_genealogy', data).then((Response2) => {
            console.log('222');
            if (Response2.data.entries.length) {
              // eslint-disable-next-line no-return-assign
              Response2.data.entries.forEach((r) => {
                r.transfer = r.lo;
                if (r.is_can_transfer) {
                  this.entriesCache.set(r, r.transfer);
                }
              });
              Response2.data.entries.forEach((r) => {
                this.entries.push(r);
              });
              this.loading = false;
              this.setData(this.entries);
              $state.loaded();
            } else {
              this.loading = false;
              $state.complete();
            }
          });
          const treeNameTranslate = {
            2: 'Личная группа',
            0: 'Полное дерево',
            1: 'Директорское',
          };
          if (this.tree_type !== null) {
            const treeName = treeNameTranslate[this.tree_type];
            const tag = this.tags.find((t) => t.key === 'tree_type');
            if (tag) {
              tag.name = treeName;
            } else if (this.tree_type !== 'full') {
              this.tags.push({ name: treeName, key: 'tree_type' });
            }
          }
          // const treeNameTranslate = {
          //   2: 'Личная группа',
          //   0: 'Полное дерево',
          //   1: 'Директорское',
          // };
          // const treeName = treeNameTranslate[this.tree_type];
          // this.tags.push({ name: treeName, key: 'tree_type' });
        });
      }
    },
  },
  computed: {
    properId() {
      if (this.selectedRow) {
        return this.selectedRow.id;
      }
      return '';
    },
    properName() {
      if (this.selectedRow) {
        return this.selectedRow.name;
      }
      return '';
    },
    showMissedGO() {
      if (!this.goEntries.length) {
        return false;
      }
      const loSummary = this.goEntries.reduce((acc, elem) => acc + elem.lo, 0);
      if (parseFloat(loSummary).toFixed(2) === parseFloat(this.selectedRowGoValue, 10).toFixed(2)) {
        return false;
      }
      return true;
    },
    howMuchMissedGO() {
      return (parseFloat(this.goEntries.reduce((acc, elem) => acc + elem.lo, 0)).toFixed(2) - parseFloat(this.selectedRowGoValue, 10).toFixed(2));
    },
    ...mapGetters('transStore', ['getReadyMulti', 'getErrorMulti']),
    ...mapState('auth', ['self_agreementsystem']),
    canMultiTrans() {
      return this.getReadyMulti.length > 0;
    },
    currentPeriod() {
      try {
        return this.periods[this.periodIndex].period;
      } catch (e) {
        return '';
      }
    },
    proportional() {
      if (this.selectedRowAgentInfo) {
        if (this.selectedRowAgentInfo.proportional !== null) {
          return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2 }).format(this.selectedRowAgentInfo?.proportional);
        }
        return '';
      }
      return '';
    },
  },
  watch: {
    currentUserId() {
      backApi.get('/agent/profile/child',
        { params: { comdte: this.periods[this.periodIndex].period, another_agent_id: this.currentUserId } })
        .then((Response) => {
          this.contextAgentInfo = Response.data;
        });
    },
    async currentPeriod() {
      if (this.currentUserId) {
        this.entries = [];
        this.loading = true;
        await backApi.get('/agent/profile/child',
          { params: { comdte: this.periods[this.periodIndex].period, another_agent_id: this.currentUserId } })
          .then((Response) => {
            this.contextAgentInfo = Response.data;
          });
        await this.updateData();
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.selectedUserInfo_wrapper{
    position: absolute;
    right: 22px;
    top: 160px;
    background: white;
    padding: 0;
    z-index: 100;
}
.selectedUserInfo_wrapper_mobile {
    position: absolute;
    // right: 22px;
    top: 160px;
    background: white;
    padding: 0;
    z-index: 100;
}
.plus_btn{
  position: absolute;
  top: -5px;
  width: auto !important;
  display: inline;
  right: 10px;
  font-size: 35px;
  font-weight: bold;
}
.selected_user_info_block{
  border: 1px solid lightgray;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(56, 58, 65, 0.24);
  & .header{
    position: relative;
  }
  & span{
    width: 50%;
    color: rgb(155, 155, 155);
    &:last-of-type{
      color: black;
    }
  }
}
.rank_icon_legend{
  width: 25px;
  margin-right: 10px;
}
.link{
    color: black;
    cursor: pointer;
}
.modal_p{
  margin-top: 10px;
  font-family: "FuturaPTDemi";
  &.error{
    color: red;
  }
}
.transmaneg_table .custom_input{
  input{
    padding-left: 0;
    background: transparent;
    border-bottom: 1px solid black;
    &:hover ~ label{
      // color: white;
    }
    &:hover{
      border-bottom: 1px solid black;
    }
    &.error{
      border-bottom: 1px solid red;
    }
    &.changed{
      border-bottom: 1px solid green;
    }
  }
  label{
    color: black;
    left: 0;
    z-index: 1;
    &:hover{
      color: white;
    }
  }
  .clear_icon{
    right: 0;
    background-image: url('../assets/imgs/close_btn_white.svg');
  }
}
.search_icons{
  position: relative;
  top: 5px;
  display: inline-block;
  width: 24px !important;
  height: 21px;
  background-image: url('../../public/icons/search.svg');
  background-size: contain;
  background-repeat: no-repeat;
  &.mobi{
    position: absolute;
    // top: 20px;
    right: 15px;
  }
}
.el-icon-circle-close:before{
  // top: 20px;
}
.qq{
  display: flex;
  align-items: center;
  & > div{
    margin-top: 20px;
  }
}
.user_name{
  display: inline-block;
  position: relative;
  text-align: right;
  color: black;
  float: right;
  padding-bottom: 0;
  margin-top: 10px;
  text-decoration: underline;
  // &::after {
  //     position: absolute;
  //     content: '';
  //     width: 100%;
  //     left: 0;
  //     bottom: 0;
  //     height: 2px;
  //     border-bottom: 1px dotted black;
  // }
}
// .user_name.depth-main::after{
//       position: absolute;
//       content: '';
//       width: 100%;
//       left: 0;
//       bottom: 0;
//       height: 2px;
//       border-bottom: 1px dotted white;
// }
.user_name.depth-main{
  color: white;
  text-decoration: underline;
}
.mobile_br{
  display: none;
}
.mobile{
  display: none;
}
.el-select{
  width: 100%;
  top: -5.5px;
}
.exp_print {
    display: inline;
    span {
      color: #32aaa7;
      cursor: pointer;
    }
}
.update{
  display: inline-block;
  // float: right;
  width: 25%;
  border: 0;
  margin-right: 10px;
  padding: 5px 30px;
  font-size: 16px;
  margin-bottom: 20px;
  background-color: #32aaa7;
  color: white;
  &.disabled{
    color: #9A9A9A;
    background-color: #DEE2F3;
  }
  // &:nth-of-type(1){
  //   width: 25%;
  //   float: none;
  //   display: inline;
  //   margin-right: 10px;
  // }
  // &:nth-of-type(2){
  //   width: 25%;
  //   float: none;
  //   display: inline;
  //   margin-right: 10px;
  // }
}
.cust_modal{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    padding-left: 120px;
    box-sizing: border-box;
    background: #FFFFFF;
    overflow-y: auto;
    box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.24);
}
.organization__modal {
    position: relative;
    // padding: 60px;
    width: 100%;
    bottom: 0;

    & .edit {
      input {
        width: 100%;
        border: 0;
        border-bottom: 1px solid #dee2f3;
        padding-bottom: 10px;
        outline: none;
        margin-bottom: 20px;
      }
      button {
        margin-top: 20px;
        width: 48%;
        border: 0;
        padding: 5px 30px;
        font-size: 16px;
        &:nth-of-type(1) {
          background-color: #32aaa7;
          color: white;
        }
        &:nth-of-type(2) {
          background-color: white;
          color: #32aaa7;
          border: 2px solid #32aaa7;
        }
      }
    }
  }
.close_btn {
    position: absolute;
    right: 0;
    top: 0px;
    font-size: 25px;
    font-weight: 500;
    color: #32aaa7;
    cursor: pointer;
}
.show_more_info_mobile{
  display: none;
}
@media (min-width: 770px) {
  .radio{
    display: inline;
  }
}
@media (max-width: 768px) {
  .selectedUserInfo_wrapper{
    display: none;
  }
  .mobile{
    display: block;
    padding: 0;
  }
  .desktop{
    display: none;
  }
}
@media (max-width: 525px) {
  .show_more_info_mobile{
    display: block;
  }
  .update{
    width: 100% !important;
  }
  .mobile_br{
    display: block;
  }
  .mt-md-5{
    & .col-md-6{
      margin-top: 20px;
    }
  }
  .search_icons{
    height: 25px;
    top: 0px;
  }
}
</style>
<style>
/* .el-table--enable-row-hover .el-table__body tr:hover > td{
  background-color: #F5F7FA;
} */
.el-table__body tr.current-row>td{
  background-color: #009b08 !important;
}
.infinite-status-prompt{
  /* display: none; */
}
.el-table .cell{
  overflow: visible;
}
.fsth{
  width: 200px !important;
}
.table th, .table td{
  vertical-align: middle;
}
.transmaneg_table th[aria-colindex='1']{
    width: 15%;
}
.transmaneg_table .el-table td{
  padding: 5px 0px;
}
.uptran{
  min-width: 360px;
}
@media (max-width: 330px) {
  .uptran{
    width: 100%;
  }
}
.uptran .el-icon-circle-close:before{
  /* top: 20px;
  right: -10px; */
}
.el-icon-circle-close{
  position: relative;
}
.el-select .el-icon-circle-close:before{
  bottom: 20px;
  right: 10px;
}
.el-table__body tr.current-row.depth-0>td{
  background-color: #bebebe !important;
}
.el-table .caret-wrapper{
  width: unset;
}
.el-table td, .el-table th.is-leaf{
  border-bottom: 1px solid #bababa!important;
  border-right: 1px solid #bababa!important;
}
.el-table--border, .el-table--group{
  border: 1px solid #bababa!important;
}
.el-table__body tr td .cell{
  /* font-weight: bold; */
  color: black;
  font-size: 14px;
}
.el-table th>.cell{
  color: black;
}
.headerClass > th{
  background-color: #dee2f3 !important;
}
</style>
